export const JOB_ROLES = [
  { value: "solution-architect", label: "Solution Architect" },
  { value: "csm", label: "CSM" },
] as const;

export type JobRole = (typeof JOB_ROLES)[number]["value"];

// Non-empty tuple required by z.enum(). JOB_ROLE_VALUES[0] is always defined
// because JOB_ROLES is a non-empty const array.
export const JOB_ROLE_VALUES = JOB_ROLES.map((r) => r.value) as [JobRole, ...JobRole[]];
